import React, { useEffect, useState } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';

import { adminApi, errorMessage } from './adminApi';
import { DataTable, DescList, EmptyState, PageHeader, Panel } from './kit';
import { formatDay, formatKmBR, formatMoneyBR, formatRelative } from './ui';
import { formatPlate } from '../garage/format';

const COLUMNS = [
  { key: 'date', label: 'Data', width: '120px', render: (m) => formatDay(m.date) },
  { key: 'company', label: 'Oficina', render: (m) => <strong className='ax-strong'>{m.companyName || '—'}</strong> },
  { key: 'customer', label: 'Cliente', render: (m) => (m.customer ? m.customer.name : '—') },
  { key: 'type', label: 'Tipo', width: '150px', render: (m) => m.type || '—' },
  { key: 'km', label: 'Km', width: '110px', align: 'right', render: (m) => formatKmBR(m.km) || '—' },
  { key: 'value', label: 'Valor', width: '120px', align: 'right', render: (m) => formatMoneyBR(m.value) },
];

// Historico de um veiculo: atendimentos do OS Digital e do Querido Carro; a linha abre o atendimento.
export default function VehiclePage() {
  const { plate } = useParams();
  const history = useHistory();
  const [state, setState] = useState({ status: 'loading', data: null, error: null });

  useEffect(() => {
    let active = true;
    setState({ status: 'loading', data: null, error: null });
    adminApi.searchMaintenances(plate)
      .then((data) => { if (active) setState({ status: 'done', data, error: null }); })
      .catch((err) => { if (active) setState({ status: 'error', data: null, error: errorMessage(err, 'Não foi possível buscar agora.') }); });
    return () => { active = false; };
  }, [plate]);

  const { data } = state;
  const results = data ? data.results : [];
  const total = results.reduce((sum, item) => sum + (item.value || 0), 0);

  return (
    <div className='ax-page'>
      <PageHeader
        crumbs={[{ label: 'Manutenções', to: '/admin/maintenances' }]}
        title={formatPlate(plate)}
        meta={data ? `${results.length} ${results.length === 1 ? 'atendimento' : 'atendimentos'}` : null}
      />

      {state.error && <p className='ax-alert' role='alert'>{state.error}</p>}
      {data && data.unavailable.length > 0 && <p className='ax-alert is-warn'>Sem resposta de {data.unavailable.join(' e ')}: a lista pode estar incompleta.</p>}

      {data && (
        <Panel title='Resumo'>
          <DescList items={[
            { label: 'Atendimentos', value: String(results.length) },
            { label: 'Valor registrado', value: formatMoneyBR(total) },
            { label: 'Último atendimento', value: results[0] ? `${formatDay(results[0].date)} (${formatRelative(results[0].date)})` : null },
            {
              label: 'Na garagem de',
              value: data.garageOwners.length
                ? data.garageOwners.map((owner, index) => (
                  <span key={owner.id}>{index > 0 && ', '}<Link to={`/admin/users/${owner.id}`}>{owner.name}</Link></span>
                ))
                : 'Nenhum cliente do Sobre Rodas',
            },
          ]} />
        </Panel>
      )}

      {(state.status === 'loading' || data) && (
        <DataTable
          columns={COLUMNS}
          rows={results}
          rowKey={(m) => m.key}
          onRowClick={(m) => history.push(`/admin/maintenances/${plate}/${encodeURIComponent(m.key)}`)}
          loading={state.status === 'loading'}
          empty={<EmptyState title='Nenhum atendimento' text='Nenhuma oficina registrou atendimento para esta placa.' />}
        />
      )}
    </div>
  );
}
